export class Routine
{
    static GOAL_DAILY = 'daily';
    static GOAL_WEEKLY = 'weekly';

    static CATEGORY_DAILY_MORNING = 'daily-morning';
    static CATEGORY_DAILY_MIDDAY = 'daily-midday';
    static CATEGORY_DAILY_EVENING = 'daily-evening';
    static CATEGORY_DAILY_GOAL = 'daily-goal';
    static CATEGORY_WEEKLY_GOAL_SPORT = 'weekly-goal-sports';
    static CATEGORY_WEEKLY_GOAL_CONSUME = 'weekly-goal-consume';
    static CATEGORY_WEEKLY_GOAL_SPIRIT = 'weekly-goal-spirit';
    static CATEGORY_WEEKLY_GOAL = 'weekly-goal';

    constructor( props = {} )
    {
        this.id = props.hasOwnProperty( 'id' ) ? props.id : 0;
        this.uuid = props.hasOwnProperty( 'uuid' ) ? props.uuid : null;
        this.goal = props.hasOwnProperty( 'goal' ) ? props.goal : null;
        this.categoryId = props.hasOwnProperty( 'categoryId' ) ? props.categoryId : null;
        this.name = props.hasOwnProperty( 'name' ) ? props.name : null;
        this.question = props.hasOwnProperty( 'question' ) ? props.question : null;
        this.customValues = props.hasOwnProperty( 'customValues' ) ? props.customValues : null;
        this.icon = props.hasOwnProperty( 'icon' ) ? props.icon : null;
        this.weeklyCount =  props.hasOwnProperty( 'weeklyCount' ) ? +props.weeklyCount : 7;
        this.weeklyFrequence =  props.hasOwnProperty( 'weeklyFrequence' ) ? props.weeklyFrequence : 7;
    }

    isStatic()
    {
        return ( this.goal === Routine.GOAL_DAILY && null === this.customValues );
    }

    getOptions()
    {
        let options = null;
        if ( this.customValues && this.customValues.length )
        {
            options = [];
            for ( let oi = 0; oi < this.customValues.length; oi ++ )
            {
                options.push( this.name.replace( '__WT__', this.customValues[ oi ] ) );
            }
        }
        return options;
    }
}
